/**
 * TanStack Query hooks for `rule-engine-with-if-then-conditional-triggers`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	ruleEngineWithIfThenConditionalTriggersQueryKeys,
	type CreateRuleEngineWithIfThenConditionalTriggersBody,
	type ListRuleEngineWithIfThenConditionalTriggersResponse,
	type RuleEngineWithIfThenConditionalTriggersRow,
} from "./api";

export function useRuleEngineWithIfThenConditionalTriggersList(): UseQueryResult<ListRuleEngineWithIfThenConditionalTriggersResponse, Error> {
	return useQuery({
		queryKey: ruleEngineWithIfThenConditionalTriggersQueryKeys.list(),
		queryFn: list,
	});
}

export function useRuleEngineWithIfThenConditionalTriggersCreate(): UseMutationResult<RuleEngineWithIfThenConditionalTriggersRow, Error, CreateRuleEngineWithIfThenConditionalTriggersBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ruleEngineWithIfThenConditionalTriggersQueryKeys.all });
		},
	});
}

export function useRuleEngineWithIfThenConditionalTriggersDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ruleEngineWithIfThenConditionalTriggersQueryKeys.all });
		},
	});
}
